import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import decode from 'jwt-decode';
import { environment } from 'environments/environment';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})

export class AuthService {

  endpoint = environment.protocol + '://' + environment.hostName + '/auth';
  headers = new HttpHeaders().set('Content-Type', 'application/json');
  public userProfileSubject = new Subject();

  public userSubject: BehaviorSubject<any>;
  public user: Observable<any>;

  constructor(
    private http: HttpClient,
    public router: Router,
    private toastr: ToastrService
  ) {
    this.userSubject = new BehaviorSubject<any>(JSON.parse(localStorage.getItem('access_token')));
    this.user = this.userSubject.asObservable();
  }

  public get userValue(): any {
    return this.userSubject.value;
  }

  injectonSubject(data) {
    this.userProfileSubject.next(data);
  }

  // Sign-up
  signUp(user: any) {
    return this.http.post(`${this.endpoint}/register-user`, user);
  }

  // Sign-in
  signIn(user: any) {
    return this.http.post<any>(`${this.endpoint}/signin`, user);
  }

  getToken() {
    return localStorage.getItem('access_token');
  }

  getTokenDecode() {
    let token = decode(this.getToken());
    return token != null && token != undefined ? token : null;
  }

  get isLoggedIn(): boolean {
    const authToken = this.getToken();
    return (authToken !== null) ? true : false;
  }

  get isAdmin(): boolean {
    const authToken: any = this.getTokenDecode();
    let ret = false;
    authToken.roles.forEach(r => {
      if (r.role === 'Administrateur')
        ret = true;
    });
    return ret;
  }

  get isArchive(): boolean {
    const authToken: any = this.getTokenDecode();
    if (!authToken) {
      return false;
    } else {
      return (authToken.role === 'Archive');
    }
  }

  get isVisiteur(): boolean {
    const authToken: any = this.getTokenDecode();
    if (!authToken) {
      return false;
    } else {
      return (authToken.role === 'Visiteur');
    }
  }

  get isUtilisateur(): boolean {
    const authToken: any = this.getTokenDecode();
    if (!authToken) {
      return false;
    } else {
      return (authToken.role === 'Utilisateur');
    }
  }

  get role(): string {
    const authToken: any = this.getTokenDecode();
    if (!authToken) {
      return '';
    } else {
      return authToken.role;
    }
  }

  doLogout() {
    const removeToken = localStorage.removeItem('access_token');
    if (removeToken == null) {
      this.toastr.warning('Vous êtes déconnecté');
      this.router.navigate(['signin']);
    }
  }

  // User profile
  getUserProfile(id): Observable<any> {
    const api = `${this.endpoint}/user-profile/${id}`;
    return this.http.get(api, { headers: this.headers }).pipe(
      map((res: Response) => {
        return res || {};
      }),
      catchError(this.handleError)
    );
  }

  // Error
  handleError(error: HttpErrorResponse) {
    let msg = '';
    if (error.error instanceof ErrorEvent) {
      // client-side error
      msg = error.error.message;
    } else {
      // server-side error
      msg = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    return throwError(msg);
  }

  resetPassword(body): Observable<any> {
    return this.http.post(`${this.endpoint}/req-reset-password`, body);
  }

  newPassword(body): Observable<any> {
    return this.http.post(`${this.endpoint}/new-password`, body);
  }

  ValidPasswordToken(body): Observable<any> {
    return this.http.post(`${this.endpoint}/valid-password-token`, body);
  }


}
